import Svg from "./Svg";

export default function Win() {
  return (
    <Svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" fill="#E9F8EF" />
      <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="#128000" />
      <path
        d="M8.08066 10.5L7.00066 5.24L5.92066 10.5H5.07066L3.59066 3.83H4.45066L5.53066 9.27L6.67066 3.83H7.34066L8.47066 9.27L9.55066 3.83H10.4107L8.93066 10.5H8.08066Z"
        fill="#128000"
      />
    </Svg>
  );
}
